import React from 'react';
import styled from 'styled-components';
import { CONTACT_EMAIL, CONTACT_PHONE } from '../../../constants/business';
import { COLOR, FONT_SIZE, LAYOUT, SPACING } from '../../../constants/theme';

const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 15;
  background: ${COLOR.surface};
  border-bottom: 1px solid ${COLOR.border};
`;

const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.lg};
  max-width: ${LAYOUT.maxWidth};
  margin: 0 auto;
  padding: 13px ${LAYOUT.gutter};
`;

const Logo = styled.img`
  display: block;
  height: 26px;
  width: auto;
`;

const Contact = styled.div`
  font-size: ${FONT_SIZE.hint};
  line-height: 1.45;
  text-align: right;
  color: ${COLOR.textSecondary};

  a {
    color: ${COLOR.primary};
    text-decoration: none;
  }
`;

const BrandHeader = () => (
  <Header>
    <Inner>
      <Logo
        alt="Telecare"
        src={`${process.env.PUBLIC_URL}/assets/slogan.svg`}
      />
      <Contact>
        {CONTACT_PHONE}
        <br />
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
      </Contact>
    </Inner>
  </Header>
);

export default BrandHeader;
